import { useReleaseDealControlMutation } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { dealRefetchAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export function useReleaseDealControl(dealId: string) {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [releaseDealControlMutation, { loading, error }] =
    useReleaseDealControlMutation();

  const releaseDealControl = async () => {
    const result = await releaseDealControlMutation({
      variables: { dealId },
    });

    const response = result.data?.releaseDealControl;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    await dealRefetch.fn();
    trackEvent('DEAL_CONTROL_RELEASED', { dealId });
    return result;
  };

  return {
    releaseDealControl,
    loading,
    error,
  };
}
